module.exports = __webpack_public_path__ + "img/logo.e2e441a6.png";